import { useCallback, useMemo } from 'react';

import { SELECTED_BANK_STATUSES } from '@/constants';
import { useAppSelector } from '@/store';

import type { TLeasingOrderResponse } from '../../../types';

const useSelectedOffer = () => {
  const { request } = useAppSelector((state) => state.ieLeasingOrder);

  const checkIsOfferSelected = useCallback(
    (response: TLeasingOrderResponse) => {
      return SELECTED_BANK_STATUSES.includes(response.status.code);
    },
    []
  );

  const selectedOffer: TLeasingOrderResponse | null = useMemo(() => {
    if (!request) return null;
    return (
      request.responses.find((response) => checkIsOfferSelected(response)) ||
      null
    );
  }, [checkIsOfferSelected, request?.responses]);

  return { selectedOffer, checkIsOfferSelected };
};

export default useSelectedOffer;
